import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PendingChangesService } from '../services/pending-change.service';
import { map } from 'rxjs/operators';
import { ConfirmStatus } from '@crdigital/crdigital-ui-sdk';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable()
export class PendingChangesGuard {
  userIsEditing: boolean = false;
  constructor(private pendingChangesService: PendingChangesService) {
    this.pendingChangesService.userIsEditing$.subscribe((userIsEditing) => {
      this.userIsEditing = userIsEditing;
    });
  }

  private isNextStateUrlRoute(path: string | undefined): boolean {
    return path === 'customerservice' ||
           path === 'cms/create-template' ||
           path === 'cms/templates/:id' ||
           path === 'cms/create-entry' ||
           path === 'cms/entries/:id' ||
           path === 'cms/entry-question-edit/:entryId/:questionId' ||
           path === 'customerservice/company/:id' ||
           path === 'customerservice/company/:companyId/employee/:employeeId';
  }

  canDeactivate(
    component: ComponentCanDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): boolean | Observable<boolean> {
    if (this.isNextStateUrlRoute(currentRoute.routeConfig?.path) && this.userIsEditing) {
      return this.pendingChangesService.openConfirmModal(currentRoute.data['confirmModalModel']).pipe(
        map((confirm) => {
          switch (confirm) {
            case ConfirmStatus.save:
              this.pendingChangesService.save.next(nextState.url);
              return false;
            case ConfirmStatus.xButton:
              return false;
            case ConfirmStatus.close:
              return true;
            default:
              return true;
          }
        })
      );
    } else {
      return true;
    }
  }
}
